<template>
    <div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form" ref="form" :rules="formRules">
            <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            
            <el-form-item label="说明" :label-width="formLabelWidth">
                <el-input v-model="form.intro" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
                <el-select v-model="form.type" @change="typeChange">
                <el-option label="顶级" :value="0"></el-option>
                <el-option :label="item.name" :value="item.key_name" :key="item.key_name" v-for="item in type"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="分类" :label-width="formLabelWidth">
                <el-tree v-if="form.type>0" :data="category" show-checkbox node-key="category_id" :default-expand-all="true" :default-checked-keys="category_ids" :props="defaultProps" @check="handleCheckChange">
                    <div class="tree-node" slot-scope="{data}">
                        <div>
                        <!-- <el-tag type="info" class="style1-tag" v-if="data.level==1">{{ type[data.type].name }}</el-tag> -->
                        <span :class="data.status == 0 ? 'text-d-line' : ''">{{ data.name }} ({{ data.category_id }}) </span>
                        <span class="red ml10" v-if="data.is_lock == 1">收费</span>
                        </div>
                    </div>
                </el-tree>
            </el-form-item>

            <el-form-item label="状态" :label-width="formLabelWidth">
                <el-radio-group v-model="form.status">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
    </div>
</template>

<script>
import CodeRoleApi from '@/api/study/code_role.js';
import CategoryApi from '@/api/study/category.js';
export default {
    data() {
        return {
            /*左边长度*/
            formLabelWidth: '120px',
            /*是否显示*/
            dialogVisible: false,
            loading: false,
            formRules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
            },
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            category: [],
            category_ids: [],
        };
    },
    props: ['open_edit', 'form', 'type'],
    created() {
        this.dialogVisible = this.open_edit;
        this.getRoleIds();
        this.typeChange();
    },
    methods: {
        // 取id
        pushId(data){
            let id = data.category_id;
            
            let index = this.category_ids.indexOf(id);
            if (index !== -1){
                this.category_ids.splice(index, 1);
            }else if(data.level == 3 || (data.type == 60 && data.level == 2) || (data.type == 83 && data.level == 1)){
                this.category_ids.push(id);
            }
            console.log(this.category_ids);
        },
        // 找子级
        findChildren(data){
            if (data.children){
                for (var i = 0; i < data.children.length; i++) {
                    this.findChildren(data.children[i]);
                }
            }else{
                this.pushId(data);
            }
        },
        //监听选中
        handleCheckChange(data, checked) {
            // console.log(this.category_ids);
            // this.findChildren(data);
            // console.log(this.category_ids);
            this.category_ids = checked.checkedKeys;
            console.log(this.category_ids);
        },
        /*选择类型*/
        typeChange(){
            let self = this;
            CategoryApi.getList({type:this.form.type}, true).then(res => {
                if (res.code == 1) {
                    self.category = res.data.list
                }
            });
        },
        /*取权限*/
        getRoleIds(){
            let self = this;
            CodeRoleApi.roleIds({role_id: self.form.role_id}, true).then(res => {
                if (res.code == 1) {
                    self.category_ids = res.data;
                }
            });
        },
        /*修改分类*/
        editCategory() {
            let self = this;
            let params = this.form;
            params.category_ids = self.category_ids.toString();
            self.$refs.form.validate((valid) => {
                if (valid) {
                self.loading = true;
                CodeRoleApi.edit(params, true)
                    .then(data =>
                    {
                        self.loading = false;
                        self.$message({
                            message: '恭喜你，修改成功',
                            type: 'success'
                        });
                        self.dialogFormVisible(true);

                    })
                    .catch(error =>
                    {
                        self.loading = false;
                    });
                }
            });
        },

        /*关闭弹窗*/
        dialogFormVisible(e) {
            if (e) {
                this.$emit('closeDialog', {
                    type: 'success',
                    openDialog: false
                })
            } else {
                this.$emit('closeDialog', {
                    type: 'error',
                    openDialog: false
                })
            }
        },

        /*上传*/
        openUpload(e) {
            this.type = e;
            this.isupload = true;
        },
        /*获取图片*/
        returnImgsFunc(e) {
            if (e != null) {
                this.form[this.type] = e[0].file_path;
                this.form[this.type+'_id'] = e[0].file_id;
            }
            this.isupload = false;
        },

    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/code/role/part/Edit.vue